import { pdf } from "@react-pdf/renderer";

interface properties {
    fileName: string;
}

async function handlePrint(
    element: React.ReactElement,
    { fileName }: properties,
) {
    const safeFileName = fileName.replace(/[.-]/g, "_");
    const blob = await pdf(element).toBlob();

    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = safeFileName;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
}

export default handlePrint;
